import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatError, MatFormField, MatFormFieldModule, MatLabel } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';
import { EcaFormColumnModule, EcaMultiSelectModule } from '@drc-eca/eca-components-lib';
import { MatInput } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';



@Component({
    selector: 'app-create-outage-modal',
    standalone: true,
    templateUrl: './create-outage-modal.component.html',
    styleUrls: ['./create-outage-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [ MatDialogModule, MatLabel, MatSelect, MatOption, MatFormField, EcaMultiSelectModule, MatError, EcaFormColumnModule, MatIcon, MatFormFieldModule, MatInput, MatButtonModule, FormsModule, ReactiveFormsModule, MatDialogModule ],
})
export class CreateOutageModalComponent {
  dialogRef = inject<MatDialogRef<CreateOutageModalComponent>>(MatDialogRef);
  data = inject(MAT_DIALOG_DATA);

  form: UntypedFormGroup = new UntypedFormGroup({
    title: new UntypedFormControl(null, Validators.required),
    description: new UntypedFormControl(null, Validators.required),
    status: new UntypedFormControl(null, Validators.required),
    severity: new UntypedFormControl(null, Validators.required),
    services: new UntypedFormControl([], Validators.required),
    clients: new UntypedFormControl([], Validators.required),
  });
  serviceSeverityList: string[] = [];
  serviceStatusList: string[] = [];
  clientList: string[] = [];
  serviceList: { label: string, value: string }[] = [];

  constructor() {
    const data = this.data;

    this.clientList = (data.clientList || []).map((cl: any) => cl.code);
    this.serviceList = (data.serviceList || []).map((sl: any) => {
      return {
        label: sl.name,
        value: sl.primaryKeyPart
      };
    });
    this.serviceStatusList = data.serviceStatusList;
    this.serviceSeverityList = data.serviceSeverityList;
  }

}
